import React from 'react';
import { motion } from 'framer-motion';
import { Shield, PiggyBank, Calendar, HelpCircle } from 'lucide-react';
interface GoalStepProps {
  onNext: (goal: string) => void;
  defaultValue?: string;
}
export function GoalStep({
  onNext,
  defaultValue
}: GoalStepProps) {
  const goals = [{
    id: 'Seguro de vida',
    icon: Shield,
    label: 'Seguro de vida'
  }, {
    id: 'Ahorrar e invertir',
    icon: PiggyBank,
    label: 'Ahorrar e invertir'
  }, {
    id: 'Planificación de retiro',
    icon: Calendar,
    label: 'Planificación de retiro'
  }, {
    id: 'No estoy seguro aún',
    icon: HelpCircle,
    label: 'No estoy seguro aún'
  }];
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-47">
      <div className="text-center mb-3 sm:mb-5" data-id="element-48">
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-49">
          ¿Qué te gustaría lograr?
        </h2>
      </div>
      <div className="space-y-1.5" data-id="element-50">
        {goals.map((goal, index) => {
        const Icon = goal.icon;
        return <motion.button key={goal.id} initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.07
        }} onClick={() => onNext(goal.id)} className={`w-full bg-white p-3 sm:p-4 rounded-lg border-2 flex items-center gap-3 transition-all duration-200 shadow-card hover:shadow-card-hover hover:scale-[1.02] ${defaultValue === goal.id ? 'border-primary text-primary' : 'border-transparent hover:border-primary text-dark'}`} data-id="element-51">
              <div className={`p-1.5 rounded-full ${defaultValue === goal.id ? 'bg-blue-50 text-primary' : 'bg-gray-50 text-gray-500'}`} data-id="element-52">
                <Icon className="w-5 h-5" data-id="element-53" />
              </div>
              <span className="text-base sm:text-lg font-medium" data-id="element-54">
                {goal.label}
              </span>
            </motion.button>;
      })}
      </div>
    </div>;
}